import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";

export default function DatePicker({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testid}
          className="w-full justify-start font-normal border-[#E2E8F0] mt-1.5">
          <CalendarIcon size={15} className="mr-2 text-[#0E2A47]/50" />
          {date ? date.toLocaleDateString("es-ES") : <span className="text-[#0E2A47]/40">Seleccionar fecha</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white" align="start">
        <Calendar mode="single" selected={date}
          onSelect={(d) => { onChange(d ? d.toISOString().slice(0, 10) : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}
